import React, { useEffect, useState } from "react";
import { Alert } from "../";
import { Schedule } from "./";
import { FiZap } from "react-icons/fi";
import { limitList } from "../../api";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

const WidgetCommands = ({ zone }) => {
  const { t } = useTranslation();
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const toggleSchedule = () => setOpenScheduleModal(!openScheduleModal);
  const [command, setCommand] = useState();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const token = Cookies.get("token");
  const commandClicked = (command) => {
    if (!command.didactic) {
      toggleSchedule();
      setCommand(command);
    } else {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: t("زمانبندی برای این Command مجاز نمی باشد."),
        type: "Warning",
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 3000);
    }
  };

  useEffect(() => {
    limitList(token).then((result) => {
      if (!result.data.data.schedule_limit) {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t(" سقف مجاز برای زمانبندی به اتمام رسیده است."),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 3000);
      }
    });
  }, []);

  return (
    <>
      {!openScheduleModal ? (
        <div>
          <i className="circleTop icon-plug text-center m-auto"></i>
          <div className="text-center mt-2">
            <p className="m-0">{t("ایجاد زمانبندی")}</p>
          </div>
          <div style={{ minHeight: "80vh", overflow: "auto" }}>
            <div className="d-flex flex-wrap justify-content-around my-3">
              {zone.commands?.map((command, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => commandClicked(command)}
                    className="mb-3 p-3 text-center bg-white allCommands mb-3 mx-auto px-2 py-2 position-relative cursor"
                  >
                    <span
                      className="commandsIcon m-auto d-block
                                    fn23 d-flex align-items-center justify-content-center rounded-circle ml-2"
                    >
                      <FiZap />
                    </span>
                    <p className="my-3 fn">
                      {command.command == "11"
                        ? t("خروجی 1 - خاموش")
                        : t("خروجی 1 - روشن")}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <Schedule
          zone={zone}
          command={command}
          toggleSchedule={toggleSchedule}
        />
      )}

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </>
  );
};

export { WidgetCommands };
